export default __webpack_public_path__ + "static/media/upload-file.b513f4e1.svg";